import setMailboxCalendarConfigurationOperation from 'owa-service/lib/operation/setMailboxCalendarConfigurationOperation';
import setMailboxCalendarConfigurationRequest from 'owa-service/lib/factory/setMailboxCalendarConfigurationRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export default function setMailboxCalendarConfiguration(options) {
    return setMailboxCalendarConfigurationOperation(setMailboxCalendarConfigurationRequest({
        Header: getJsonRequestHeader(),
        Options: options,
    }));
}
//# sourceMappingURL=setMailboxCalendarConfiguration.js.map